import { render, staticRenderFns } from "./Jkos.vue?vue&type=template&id=4c345613"
import script from "./Jkos.vue?vue&type=script&lang=js"
export * from "./Jkos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports